/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  'cls-1': { fill: 'none' },
  'cls-2': { fill: '#018374' },
  'cls-3': { fill: '#02bc94' },
  'cls-4': { fill: '#FFFFFF' },
});
const LogoVertical = () => {
  const classes = useStyles();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 423.38 292.48"
    >
      <title>bh_lg_stk_rgb_pos</title>
      <rect className={classes['cls-1']} width="423.38" height="292.48" />
      <path
        className={classes['cls-2']}
        d="M293.2,79.8a6.16,6.16,0,0,1,4.22-11.58,12.87,12.87,0,0,0-8.8,24.19l63.22,23-54.42,19.81a12.87,12.87,0,0,1-8.8-24.19A19.57,19.57,0,0,0,302,147.83l59.38-21.61a11.49,11.49,0,0,0,0-21.6Z"
      />
      <path
        className={classes['cls-3']}
        d="M351.84,88,297.42,68.22a12.87,12.87,0,0,0-8.8,24.19A19.57,19.57,0,0,1,302,55.62l59.38,21.61a11.49,11.49,0,0,1,0,21.6L293.2,123.65a6.16,6.16,0,0,0,4.22,11.58,12.87,12.87,0,0,1-8.8-24.19l63.22-23"
      />
      <path
        className={classes['cls-4']}
        d="M139.77,149H129.39v-4.79h-.32a14.66,14.66,0,0,1-12.45,6.07c-7.42,0-17.4-6-17.4-20.44,0-12.29,8.46-20.11,18.2-20.11a13.41,13.41,0,0,1,11.65,6h.32v-5h10.38ZM120,140.94c5.11,0,9.58-4.47,9.58-10.94,0-6.7-4.15-11.09-9.5-11.09-6.7,0-9.89,5.51-9.89,11S113.27,140.94,120,140.94Zm40.93-7.66-2.48,2.39V149H147.65V91.53h10.77V123.7l12.13-12.93h13.09l-15.32,15.72L186,149H173ZM253.52,120a27.69,27.69,0,0,0-5.11-.48c-6.38,0-9.58,4-9.58,10.85V149H228.06V110.77H238.6v5.91h.23a13,13,0,0,1,11.18-7,14.62,14.62,0,0,1,3.51.32Zm-31.19,9.58a18.31,18.31,0,0,1-.16,2.87H193.76a10,10,0,0,0,9.9,9.82,8.73,8.73,0,0,0,7.66-4l8.89,3.24c-3,5-8.31,8.82-16.63,8.82-11.42,0-20.35-8.3-20.35-20.75,0-10.94,7.18-20.12,19.63-20.12C215.47,109.49,222.33,118.91,222.33,129.61Zm-28.49-4.47h17.88a9,9,0,0,0-17.88,0ZM54.43,94.57h18.8c11.25,0,18.83,4.55,18.83,13.73,0,6.06-4.39,10.13-9.74,11.41v.16c8.3,1.12,12.61,7,12.61,13.49,0,10-8.14,15.64-19,15.64H54.43Zm18.24,8.54H65.21v13.17h7.86c5.34,0,7.74-2.64,7.74-6.87C80.81,105.34,77.77,103.11,72.67,103.11Zm1.67,21.55H65.21v15.72h9.61c5.59,0,8.62-2.95,8.62-8C83.44,127.85,80.17,124.66,74.34,124.66ZM86.8,194.39h-21v23.14H54.43V163.1H65.84v21.39h21V163.1H98.21v54.43H86.8Zm54.35,23.14h-10.7v-4.79h-.24A12.77,12.77,0,0,1,119,218.81c-6.22,0-13.89-3.83-13.89-16.84V179.3h10.78v21.31c0,5.59,2.63,8.62,6.78,8.62,4.71,0,7.66-3.27,7.66-9.65V179.3h10.78Zm46.11-1.19c0,14.2-6.39,21.71-20.51,21.71-9.27,0-15.84-4.38-18.36-11.73l9.9-3.6c.8,3.67,3.51,6.55,9.1,6.55,6.46,0,9.81-4.07,9.81-11.5V212.9H177a15,15,0,0,1-12.21,5.51c-9.89,0-18-7.74-18-20.11,0-11.49,7.91-20.19,18.52-20.19a13.6,13.6,0,0,1,11.57,5.82h.4V179.3h10.06ZM167.39,209c5.34,0,9.73-4.39,9.73-10.69,0-6.55-4.23-10.86-9.65-10.86-6.47,0-9.82,5.43-9.82,10.78S160.68,209,167.39,209Zm27.43-48.92H205.6v24h.32a12.8,12.8,0,0,1,11.25-6c8.54,0,14.52,5.66,14.52,17.48v21.94H220.92V196.22c0-5.66-2.71-8.62-7.18-8.62-4.71,0-8.14,3.28-8.14,9.74v20.19H194.82Zm80.91,38.07a18.25,18.25,0,0,1-.16,2.87H247.16a10,10,0,0,0,9.89,9.82,8.75,8.75,0,0,0,7.67-4l8.89,3.23c-3,5-8.31,8.82-16.64,8.82-11.41,0-20.35-8.3-20.35-20.75,0-10.94,7.19-20.11,19.64-20.11C268.87,178,275.73,187.44,275.73,198.14Zm-28.49-4.47h17.88a9,9,0,0,0-17.88,0ZM298,189.6c-.24-2.71-2-4.31-4.39-4.31-2.56,0-3.91,1.68-3.91,3.35,0,2.16,1.19,3.51,7.66,5.75,8.06,2.63,11,6.7,11,12.21,0,7-5.34,12.29-14.76,12.29-9.74,0-14.37-5.11-14.77-12.53h9.66c.24,3,1.84,5.19,5.35,5.19a4.08,4.08,0,0,0,4.39-4.07c0-2.64-1.84-4.23-7.59-6.15-7.18-2.31-10.93-5.9-10.93-11.89,0-6.86,5.59-11.41,13.81-11.41,8.46,0,13.17,4.86,14,11.57Z"
      />
    </svg>
  );
};

export default LogoVertical;
